import { useFormContext } from "react-hook-form";
import { Card } from "../Card";
import Icon from "../Icon/Icon";

interface CardStepProps {
    title: string;
    description: string;
    icon: string;
    step: number
    children?: JSX.Element
}

export const CardStep: React.FC<CardStepProps> = ({ title, description, icon, step, children }) => {
    const opacity = ['_', '_', 'opacity-60', 'opacity-30', 'opacity-10', 'opacity-10']
    const formContexts = useFormContext()
    const activeStep = formContexts.watch('activeStep')

    const isInactive = activeStep < step
    const isActive = activeStep === step
    const isCompleted = activeStep > step
    return <Card className={`max-w-3xl h-fit relative ${!isActive && isInactive && opacity[step]} ${isActive ? 'ring-1 ring-primary-500' : 'ring-1 ring-gray-700'}`}>
        <div className="flex justify-between w-full items-center">
            <div className="flex gap-4 text-white-500 items-center">
                <Icon name={icon} size={24} className="!max-w-[24px] !min-w-[24px]" />
                <div className="flex flex-col gap-1 w-full justify-start text-left items-start">
                    <h1 className="font-bold capitalize ">{title}</h1>
                    <small className="text-gray-400">{description}</small>
                </div>
            </div>
            {!isActive && !isCompleted && <Icon name="check-circle" size={18} className="text-gray-500" />}
            {isActive ? <Icon name="check-circle" size={16} className="text-gray-500" /> : null}
            {isCompleted && <Icon name="check-circle" size={18} className="text-primary-500" />}
        </div>
        {step === 1 && children}
        {isActive && children}
    </Card>
}